export default __webpack_public_path__ + "static/media/CNo.12-3.4d4fb16f.jpg";